import template from './documents_help.html';
import * as Utils from '../../lib/savanna_utils.js';
import * as Permissions from '../../lib/permission_utils.js';

class DocumentHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class DocumentHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new DocumentHelpViewModel(this);
		this.bindings = bindings;
	};

	async init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'DocumentsHelp',
	dialog_class: DocumentHelpPage,
	template: template,
	template_filename: 'translation/dialogs/documents_help',
	provider: 'ps'
};
